import { CollapsibleCard, Grid, TextField } from '@atgfr8/atg-ui-tailwind';
import { sanitizeStateInput } from '@utils/formUtils';
import AddressAutoComplete, {
  AddressDetails,
} from '@components/Autocomplete/AddressAutoComplete';
import { prospectDetailsStore, updateProspectDetails } from '@store/prospect';
import { Component } from 'solid-js';

import { validateFieldForProspect } from './utils';

export const ProspectDetailsAddressCard: Component = () => {
  const validateAddressFields = async () => {
    const fields = ['address1', 'city', 'state', 'zip'];
    for (const field of fields) {
      await validateFieldForProspect(field, field);
    }
  };

  const handleGooglePlacesSelect = async (place: AddressDetails) => {
    const { address1 = '', city = '', state = '', zipCode = '' } = place;
    updateProspectDetails({
      address1: address1,
      city: city,
      state: state.substring(0, 2), // max length of 2,
      zip: zipCode,
    });

    await validateAddressFields();
  };

  return (
    <CollapsibleCard
      startTitle={'Address'}
      loading={prospectDetailsStore.loading}
      class="mb-2"
    >
      <Grid container gap={1}>
        <Grid item size={12}>
          <AddressAutoComplete
            label="Address line 1"
            placeholder="Enter Address"
            value={prospectDetailsStore.prospectDetails.address1 ?? ''}
            onChange={async (val) => {
              updateProspectDetails({
                address1: val,
              });
              await validateFieldForProspect('address1', 'address1');
            }}
            onBlur={validateAddressFields}
            onItemSelect={handleGooglePlacesSelect}
            zIndex="9999"
            maxLength={50}
            error={
              prospectDetailsStore.prospectDetailsErrors
                ? prospectDetailsStore.prospectDetailsErrors['address1']
                : ''
            }
          />
        </Grid>
        <Grid item size={12}>
          <TextField
            label="Address line 2"
            placeholder="Enter Address"
            value={prospectDetailsStore.prospectDetails.address2 ?? ''}
            onChange={(val: string) => {
              updateProspectDetails({
                address2: val,
              });
            }}
            maxLength={50}
            dataTestId={'address-line-2-textInput'}
          />
        </Grid>
        <Grid container spacing={1}>
          <Grid item size={{ md: 12, lg: 6 }}>
            <TextField
              label="City"
              value={prospectDetailsStore.prospectDetails.city ?? ''}
              onChange={async (val: string) => {
                updateProspectDetails({ city: val });
                await validateFieldForProspect('city', 'city');
              }}
              on:blur={validateAddressFields}
              maxLength={50}
              error={prospectDetailsStore.prospectDetailsErrors?.['city'] ?? ''}
              dataTestId={'city-textInput'}
            />
          </Grid>
          <Grid item size={{ md: 12, lg: 2 }}>
            <TextField
              label="State"
              value={prospectDetailsStore.prospectDetails.state ?? ''}
              onChange={async (val: string) => {
                const sanitized = sanitizeStateInput(val);
                const current =
                  prospectDetailsStore.prospectDetails.state ?? '';
                if (sanitized === current) return;
                updateProspectDetails({ state: sanitized });
                await validateFieldForProspect('state', 'state');
              }}
              on:blur={validateAddressFields}
              maxLength={2}
              error={
                prospectDetailsStore.prospectDetailsErrors?.['state'] ?? ''
              }
              dataTestId={'state-textInput'}
            />
          </Grid>
          <Grid item size={{ md: 12, lg: 4 }}>
            <TextField
              label="Zip"
              value={prospectDetailsStore.prospectDetails.zip ?? ''}
              onChange={async (val: string) => {
                updateProspectDetails({ zip: val });
                await validateFieldForProspect('zip', 'zip');
              }}
              on:blur={validateAddressFields}
              maxLength={10}
              error={prospectDetailsStore.prospectDetailsErrors?.['zip'] ?? ''}
              dataTestId={'zip-textInput'}
            />
          </Grid>
        </Grid>
      </Grid>
    </CollapsibleCard>
  );
};
